module.exports = __webpack_public_path__ + "img/addholdbill.6d821f37.svg";